var $e038a7e7a6d81989$exports = {};
$e038a7e7a6d81989$exports = {
    "dropzoneLabel": `DropZone`,
    "selectPlaceholder": `\u{62D}\u{62F}\u{62F} \u{639}\u{646}\u{635}\u{631}\u{64B}\u{627}`,
    "tableResizer": `\u{623}\u{62F}\u{627}\u{629} \u{62A}\u{63A}\u{64A}\u{64A}\u{631} \u{627}\u{644}\u{62D}\u{62C}\u{645}`,
    "colorSwatchPicker": `Color swatches`
};


export {$e038a7e7a6d81989$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
